import React from 'react';
export function GestionSection() {
  const features = [{
    title: 'Planificaciones Anuales editables (1.º a 6.º):',
    desc: 'copiás, ponés tu nombre y entregás.'
  }, {
    title: '18 Evaluaciones Trimestrales (Modelo A y B):',
    desc: 'dos versiones + clave de corrección + criterios de calificación.'
  }, {
    title: 'Rúbricas de seguimiento y calificación:',
    desc: 'planilla grupal para hasta 30 alumnos de un vistazo.'
  }, {
    title: 'Proyectos ESI en Ciencias Sociales:',
    desc: 'alineados a la Ley 26.150. Listos para supervisión.'
  }, {
    title: 'Proyecto de Educación Ambiental Integral:',
    desc: 'basado en la Ley 27.621. Con diagnóstico y rúbrica.'
  }];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border" data-id="element-115">
      <div className="max-w-4xl mx-auto" data-id="element-116">
        <div className="text-center mb-12" data-id="element-117">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-118">
            🎯 ADEMÁS: EL SISTEMA DE GESTIÓN DOCENTE 360
          </h2>
          <p className="text-brand-accent italic font-medium text-lg mb-6" data-id="element-119">
            Solo disponible en el Pack Completo
          </p>
          <p className="text-white/80 text-xl max-w-2xl mx-auto leading-relaxed" data-id="element-120">
            El material que la maestra{' '}
            <span className="font-bold text-white" data-id="element-121">NO le da al alumno</span>{' '}
            sino que presenta a la Directora y usa para calificar sin quedarse
            hasta las 2 de la mañana.
          </p>
        </div>

        <div className="bg-brand-card rounded-2xl p-8 md:p-12 border border-brand-accent/40 shadow-xl" data-id="element-122">
          <div className="flex flex-col gap-6 md:gap-8" data-id="element-123">
            {features.map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-124">
                <div className="flex-shrink-0 w-8 h-8 bg-brand-accent/20 rounded-md flex items-center justify-center mt-0.5 text-brand-accent font-black" data-id="element-125">
                  ✓
                </div>
                <p className="text-white/90 text-lg leading-relaxed" data-id="element-126">
                  <span className="font-bold text-white block md:inline md:mr-2" data-id="element-127">
                    {item.title}
                  </span>
                  {item.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}